@if (topMessages | dsl | async; as messages) {
    <vn-content-messages class="content-messages-top" [messages]="messages" closedCookieKey="vn-tm" cssClassForHtmlNode="has-top-messages" />
}
